import React, { useRef, useState, useEffect } from 'react';
import { Image } from 'react-bootstrap';

const VideoPlayer = ({ videoSrc, posterSrc, title, onVideoPlayingChange }) => { // Add onVideoPlayingChange prop
  const videoRef = useRef(null);
  const [showVideo, setShowVideo] = useState(false);

  const handlePosterClick = () => {
    setShowVideo(true);
  };

  useEffect(() => {
    if (showVideo && videoRef.current) {
      videoRef.current.muted = true;
      videoRef.current.play()
        .then(() => {
          console.log("Video started playing automatically.");
          if (onVideoPlayingChange) {
            onVideoPlayingChange(true); // Notify parent that video is playing
          }
        })
        .catch(error => {
          console.error("Autoplay prevented:", error);
          if (onVideoPlayingChange) {
            onVideoPlayingChange(false); // Notify parent if autoplay failed, keep poster
          }
          setShowVideo(false); // Revert to poster if autoplay fails
        });
    } else if (!showVideo && onVideoPlayingChange) {
      onVideoPlayingChange(false); // Notify parent that video is not playing (e.g., if poster is shown)
    }
  }, [showVideo, onVideoPlayingChange]); // Add onVideoPlayingChange to dependency array

  // Handle video ending
  const handleVideoEnded = () => {
    setShowVideo(false);
    if (onVideoPlayingChange) {
      onVideoPlayingChange(false); // Notify parent that video has ended
    }
  };

  return (
     <div className="w-100 h-100">
      {!showVideo ? (
        <div
          className="video-poster-container position-relative w-100 h-100"
          onClick={handlePosterClick}
          style={{ cursor: 'pointer' }}
        >
          <Image
            src={posterSrc}
            alt={`${title} Poster`}
            fluid
            className="w-100 h-100 object-fit-cover rounded-3"
            style={{ borderRadius: '8px' }}
          />
          <div
            className="play-button position-absolute top-50 start-50 translate-middle"
            style={{
              fontSize: '4rem',
              color: 'white',
              opacity: '0.8',
              textShadow: '2px 2px 4px rgba(0,0,0,0.5)',
              zIndex: '1000',
            }}
          >
            &#9658; {/* Unicode play symbol */}
          </div>
        </div>
      ) : (
        <video
          ref={videoRef}
          controls
          className="w-100 h-100 object-fit-cover rounded-3"
          style={{ borderRadius: '8px' }}
          onEnded={handleVideoEnded} // Use the new handler
          muted // Keep muted for robust initial autoplay, user can unmute
          playsInline
        >
          <source src={videoSrc} type="video/mp4" />
          Your browser does not support the video tag.
        </video>
      )}
    </div>
  );
};

export default VideoPlayer;